import classNames from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
import { ToasterStore } from './toaster.mobx-store';
import styles from "./toaster.module.css";
/**
 * ### The Toaster component.
 *
 * @remarks
 * Parent component of all Toasts within an application. There should only be one toaster on
 * the page, because it reads from a singleton via `toaster.mobx-store.tsx`.
 *
 * Within the django-website, you never need to render it yourself, because the ui-feedback
 * app renders it. You only need to use the methods on `toaster.mobx-store.js` to add or remove
 * toasts.
 *
 * This component will always insert an div with role `status` and `aria-live="polite"` so
 * assistive technology will know to announce a toast if one is added to the DOM.
 */

export const Toaster = Object.assign(observer(() => {
  const toastComponents = [];
  ToasterStore.toasts.forEach(toast => toastComponents.push(toast.toastComponent));
  return /*#__PURE__*/React.createElement("div", {
    id: "toaster",
    role: "status",
    "aria-live": "polite",
    className: classNames(styles.toaster, {
      [styles.toasted]: !!toastComponents.length
    })
  }, toastComponents);
}), {
  displayName: 'Toaster'
});
//# sourceMappingURL=toaster.react-component.js.map